/**
 * Placeholder data-integration data for the three sub-pages. Replace with the
 * integration API: source registry, import jobs and sync schedules.
 */

/* ========================================================== Data Sources -- */

export const SOURCE_STATS = [
  {
    key: "total",
    label: "Total Data Sources",
    value: "32",
    foot: "All configured sources",
    tone: "blue",
    icon: "database",
  },
  {
    key: "active",
    label: "Active Sources",
    value: "28",
    foot: "87.5% of total sources",
    footTone: "good",
    tone: "green",
    icon: "check",
  },
  {
    key: "last",
    label: "Last Data Ingestion",
    value: "15 min ago",
    foot: "01 Sep 2026, 10:30 AM",
    tone: "amber",
    icon: "sync",
  },
  {
    key: "success",
    label: "Successful Ingestions",
    value: "1,248",
    foot: "This month",
    tone: "indigo",
    icon: "trend",
  },
  {
    key: "failed",
    label: "Failed Ingestions",
    value: "18",
    foot: "This month",
    tone: "red",
    icon: "alert",
  },
  {
    key: "records",
    label: "Total Records",
    value: "245.6M",
    foot: "Across all sources",
    tone: "sky",
    icon: "file",
  },
];

export const SOURCE_TYPES = ["Government", "Financial", "Internal", "External"];
export const SOURCE_STATUSES = ["Success", "Warning", "Failed"];

export const TOTAL_SOURCES = 32;

export const DATA_SOURCES = [
  {
    code: "NCR",
    name: "National Civil Registry",
    type: "Government",
    icon: "bank",
    tone: "green",
    owner: "Civil Registry Dept.",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "10:30 AM",
    status: "Success",
    records: "45.2M",
  },
  {
    code: "SIC",
    name: "Customs Declaration System",
    type: "Government",
    icon: "anchor",
    tone: "blue",
    owner: "Customs Authority",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "09:45 AM",
    status: "Success",
    records: "32.7M",
  },
  {
    code: "BFI",
    name: "Banking & Financial Institutions",
    type: "Financial",
    icon: "bank",
    tone: "indigo",
    owner: "Financial Sector Unit",
    frequency: "Weekly",
    date: "31 Aug 2026",
    time: "11:20 PM",
    status: "Success",
    records: "28.9M",
  },
  {
    code: "INSS",
    name: "Social Security System",
    type: "Government",
    icon: "users",
    tone: "amber",
    owner: "Social Security Inst.",
    frequency: "Weekly",
    date: "31 Aug 2026",
    time: "08:10 PM",
    status: "Success",
    records: "21.6M",
  },
  {
    code: "CRC",
    name: "Commercial Registry",
    type: "Government",
    icon: "building",
    tone: "sky",
    owner: "Commercial Registry",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "10:15 AM",
    status: "Warning",
    records: "18.4M",
  },
  {
    code: "PAA",
    name: "Port & Airport Authority",
    type: "Government",
    icon: "anchor",
    tone: "red",
    owner: "Port & Airport Authority",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "08:50 AM",
    status: "Success",
    records: "8.7M",
  },
  {
    code: "TPS",
    name: "Tax Payment System",
    type: "Internal",
    icon: "file",
    tone: "blue",
    owner: "DGI – IT Department",
    frequency: "Real-time",
    date: "01 Sep 2026",
    time: "10:30 AM",
    status: "Success",
    records: "56.1M",
  },
  {
    code: "CRS",
    name: "International CRS Data",
    type: "External",
    icon: "globe",
    tone: "indigo",
    owner: "International Relations",
    frequency: "Monthly",
    date: "29 Aug 2026",
    time: "06:30 AM",
    status: "Failed",
    records: "3.2M",
  },
];

export const TOTAL_TYPE_SOURCES = 32;

export const TYPE_DISTRIBUTION = [
  {
    label: "Government",
    value: 18,
    share: 56.3,
    color: "#26a269",
    legendPrimary: "18",
    legendSecondary: "(56.3%)",
  },
  {
    label: "Financial",
    value: 6,
    share: 18.8,
    color: "#7a4fd0",
    legendPrimary: "6",
    legendSecondary: "(18.8%)",
  },
  {
    label: "Internal",
    value: 2,
    share: 6.3,
    color: "#1b6fd6",
    legendPrimary: "2",
    legendSecondary: "(6.3%)",
  },
  {
    label: "External",
    value: 4,
    share: 12.5,
    color: "#ef9c17",
    legendPrimary: "4",
    legendSecondary: "(12.5%)",
  },
  {
    label: "Other",
    value: 2,
    share: 6.3,
    color: "#9aa7bb",
    legendPrimary: "2",
    legendSecondary: "(6.3%)",
  },
];

export const INGESTION_HEALTH = [
  { label: "Successful", count: "1,248", share: 92.1, color: "#26a269" },
  { label: "Warning", count: "34", share: 2.5, color: "#ef9c17" },
  { label: "Failed", count: "18", share: 1.3, color: "#df3f45" },
  { label: "In Progress", count: "52", share: 3.8, color: "#1b6fd6" },
];

export const INGESTION_ACTIVITY = [
  {
    id: 1,
    time: "01 Sep 2026, 10:30 AM",
    source: "National Civil Registry (NCR)",
    mode: "Full Load",
    records: "15.2M records",
    status: "Success",
    duration: "12m 34s",
  },
  {
    id: 2,
    time: "01 Sep 2026, 09:45 AM",
    source: "Customs Declaration System (SIC)",
    mode: "Incremental",
    records: "3.1M records",
    status: "Success",
    duration: "8m 21s",
  },
  {
    id: 3,
    time: "01 Sep 2026, 08:15 AM",
    source: "Commencial Registry (CRC)",
    mode: "Incremental",
    records: "—",
    status: "Warning",
    duration: "—",
  },
  {
    id: 4,
    time: "31 Aug 2026, 11:00 PM",
    source: "International CRS Data (CRS)",
    mode: "Full Load",
    records: "—",
    status: "Failed",
    duration: "—",
  },
];

export const SOURCE_QUICK_ACTIONS = [
  {
    key: "add",
    title: "Add New Source",
    text: "Configure a new data source connection.",
    icon: "plus",
  },
  {
    key: "test",
    title: "Test Connection",
    text: "Test connectivity to an existing source.",
    icon: "plug",
  },
  {
    key: "map",
    title: "Manage Mappings",
    text: "View and manage source field mappings.",
    icon: "grid",
  },
  {
    key: "settings",
    title: "Ingestion Settings",
    text: "Configure schedules and notifications.",
    icon: "settings",
  },
];

/* ========================================================== Import Data -- */

export const IMPORT_STEPS = [
  { key: "upload", title: "Upload File", hint: "Select and upload data file" },
  { key: "source", title: "Choose Source", hint: "Select data source" },
  { key: "map", title: "Map Data", hint: "Map fields to system" },
  { key: "validate", title: "Validate Data", hint: "Verify and preview data" },
  { key: "complete", title: "Import & Complete", hint: "Start import process" },
];

export const IMPORT_METHODS = [
  {
    key: "file",
    label: "Upload File",
    text: "Import data from your local file (CSV, Excel, XML).",
    icon: "cloudUpload",
    tone: "green",
  },
  {
    key: "database",
    label: "Database Connection",
    text: "Import data directly from a database connection.",
    icon: "database",
    tone: "blue",
  },
  {
    key: "api",
    label: "API Integration",
    text: "Import data from an external API endpoint.",
    icon: "cloud",
    tone: "indigo",
  },
  {
    key: "sftp",
    label: "SFTP / FTP",
    text: "Import data from a file on SFTP or FTP server.",
    icon: "folder",
    tone: "amber",
  },
];

export const UPLOADED_FILE = {
  name: "Taxpayer_Master_2026-09-01.xlsx",
  size: "125.6 MB",
  rows: "245,678 rows",
};

export const IMPORT_SUMMARY = [
  {
    label: "Selected Source",
    value: "National Civil Registry (NCR)",
    chip: "Active",
    icon: "database",
  },
  {
    label: "File Name",
    value: "Taxpayer_Master_2026-09-01.xlsx",
    icon: "sheet",
  },
  { label: "File Size", value: "125.6 MB", icon: "file" },
  { label: "Total Rows", value: "245,678", icon: "grid" },
  { label: "Uploaded By", value: "John Doe", icon: "user" },
  { label: "Upload Time", value: "01 Sep 2026 10:45 AM", icon: "clock" },
];

export const PREVIEW_TOTAL = "245,678";

export const PREVIEW_BREAKDOWN = [
  {
    label: "Valid Rows",
    value: 230812,
    share: 93.9,
    color: "#26a269",
    legendPrimary: "230,812",
    legendSecondary: "(93.9%)",
  },
  {
    label: "Invalid Rows",
    value: 8954,
    share: 3.6,
    color: "#df3f45",
    legendPrimary: "8,954",
    legendSecondary: "(3.6%)",
  },
  {
    label: "Duplicates",
    value: 4912,
    share: 2.0,
    color: "#ef9c17",
    legendPrimary: "4,912",
    legendSecondary: "(2.0%)",
  },
  {
    label: "Empty Rows",
    value: 1000,
    share: 0.4,
    color: "#9aa7bb",
    legendPrimary: "1,000",
    legendSecondary: "(0.4%)",
  },
];

export const IMPORT_JOBS = [
  {
    id: "IMP-2026-00045",
    source: "National Civil Registry (NCR)",
    file: "Taxpayer_Master_2026-08-30.xlsx",
    rows: "210,456",
    status: "Completed",
    startedBy: "John Doe",
    start: "30 Aug 2026 09:15 AM",
    duration: "12m 34s",
  },
  {
    id: "IMP-2026-00044",
    source: "Customs Declaration System (SIC)",
    file: "Imports_2026-08-29.csv",
    rows: "98,765",
    status: "Completed",
    startedBy: "Jane Smith",
    start: "29 Aug 2026 04:30 PM",
    duration: "08m 21s",
  },
  {
    id: "IMP-2026-00043",
    source: "Banking & Financial Institutions (BFI)",
    file: "Bank_Data_2026-08-28.xlsx",
    rows: "156,342",
    status: "Failed",
    startedBy: "John Doe",
    start: "28 Aug 2026 11:20 AM",
    duration: "05m 12s",
  },
  {
    id: "IMP-2026-00042",
    source: "Social Security System (INSS)",
    file: "SS_Contributors_2026-08-27.csv",
    rows: "76,980",
    status: "Completed",
    startedBy: "Maria Fernandes",
    start: "27 Aug 2026 10:05 AM",
    duration: "09m 45s",
  },
];

/* ======================================================= Synchronization -- */

export const SYNC_STATS = [
  {
    key: "active",
    label: "Active Synchronizations",
    value: "12",
    foot: "Across 8 data sources",
    tone: "green",
    icon: "sync",
  },
  {
    key: "last",
    label: "Last Successful Sync",
    value: "5 min ago",
    foot: "01 Sep 2026, 10:25 AM",
    footTone: "good",
    tone: "blue",
    icon: "clock",
  },
  {
    key: "today",
    label: "Records Synced Today",
    value: "3.45M",
    foot: "+8.7% vs yesterday",
    footTone: "good",
    tone: "indigo",
    icon: "refresh",
  },
  {
    key: "issues",
    label: "Syncs with Issues",
    value: "2",
    foot: "View and resolve",
    footTone: "warn",
    tone: "amber",
    icon: "alert",
  },
  {
    key: "total",
    label: "Total Records Synced",
    value: "245.6M",
    foot: "All time",
    tone: "sky",
    icon: "database",
  },
];

export const SYNC_TYPES = ["Government", "Financial", "Internal", "External"];

export const TOTAL_SYNC_SOURCES = 12;

export const SYNC_SOURCES = [
  {
    code: "NCR",
    name: "National Civil Registry",
    type: "Government",
    icon: "bank",
    tone: "green",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "10:25 AM",
    status: "Success",
    records: "1.24M",
  },
  {
    code: "SIC",
    name: "Customs Declaration System",
    type: "Government",
    icon: "anchor",
    tone: "blue",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "10:20 AM",
    status: "Success",
    records: "856K",
  },
  {
    code: "BFI",
    name: "Banking & Financial Institutions",
    type: "Financial",
    icon: "bank",
    tone: "indigo",
    frequency: "Hourly",
    date: "01 Sep 2026",
    time: "10:15 AM",
    status: "Success",
    records: "672K",
  },
  {
    code: "INSS",
    name: "Social Security System",
    type: "Government",
    icon: "users",
    tone: "amber",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "09:50 AM",
    status: "Warning",
    records: "412K",
  },
  {
    code: "TPS",
    name: "Tax Payment System",
    type: "Internal",
    icon: "file",
    tone: "blue",
    frequency: "Real-time",
    date: "01 Sep 2026",
    time: "10:25 AM",
    status: "Success",
    records: "128K",
  },
  {
    code: "CRS",
    name: "International CRS Data",
    type: "External",
    icon: "globe",
    tone: "indigo",
    frequency: "Weekly",
    date: "31 Aug 2026",
    time: "06:30 AM",
    status: "Success",
    records: "96K",
  },
  {
    code: "PAA",
    name: "Port & Airport Authority",
    type: "Government",
    icon: "anchor",
    tone: "red",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "09:10 AM",
    status: "Failed",
    records: "24K",
  },
  {
    code: "CRC",
    name: "Commercial Registry",
    type: "Government",
    icon: "building",
    tone: "sky",
    frequency: "Daily",
    date: "01 Sep 2026",
    time: "10:05 AM",
    status: "Success",
    records: "86K",
  },
];

export const TOTAL_SYNCS = 12;

export const SYNC_HEALTH = [
  {
    label: "Successful",
    value: 9,
    share: 75.0,
    color: "#26a269",
    legendPrimary: "9",
    legendSecondary: "(75.0%)",
  },
  {
    label: "Warning",
    value: 1,
    share: 8.3,
    color: "#ef9c17",
    legendPrimary: "1",
    legendSecondary: "(8.3%)",
  },
  {
    label: "Failed",
    value: 2,
    share: 16.7,
    color: "#df3f45",
    legendPrimary: "2",
    legendSecondary: "(16.7%)",
  },
];

export const PERF_DAYS = [
  "26 Aug",
  "27 Aug",
  "28 Aug",
  "29 Aug",
  "30 Aug",
  "31 Aug",
  "01 Sep",
];

export const PERF_SERIES = [
  {
    key: "records",
    label: "Records synced",
    color: "#1b6fd6",
    values: [2.15, 2.62, 2.38, 3.12, 2.74, 3.42, 3.05, 3.45],
  },
];

export const SYNC_ACTIVITY = [
  {
    id: 1,
    time: "01 Sep 2026, 10:25 AM",
    source: "National Civil Registry (NCR)",
    status: "Success",
    records: "1.24M",
    duration: "3m 45s",
  },
  {
    id: 2,
    time: "01 Sep 2026, 10:20 AM",
    source: "Customs Declaration System (SIC)",
    status: "Success",
    records: "856K",
    duration: "2m 18s",
  },
  {
    id: 3,
    time: "01 Sep 2026, 10:15 AM",
    source: "Banking & Financial Institutions (BFI)",
    status: "Success",
    records: "672K",
    duration: "1m 52s",
  },
  {
    id: 4,
    time: "01 Sep 2026, 09:50 AM",
    source: "Social Security System (INSS)",
    status: "Warning",
    records: "412K",
    duration: "2m 33s",
  },
  {
    id: 5,
    time: "01 Sep 2026, 09:10 AM",
    source: "Port & Airport Authority (PAA)",
    status: "Failed",
    records: "24K",
    duration: "1m 05s",
  },
];

export const NEXT_SYNCS = [
  { key: "sic", label: "Customs Declaration System (SIC)", when: "Today, 11:00 AM" },
  { key: "inss", label: "Social Security System (INSS)", when: "Today, 11:30 AM" },
  { key: "crc", label: "Commercial Registry (CRC)", when: "Today, 12:00 PM" },
];
